import { useMutation } from '@apollo/client';
import CreateBuildWithAIRevisionPredictionAsync from './CreateBuildWithAIRevisionPredictionAsync.graphql';
/**
 * GraphQL mutation operation to create a Build with AI survey revision.
 *
 * Requires a survey as input so that a survey revised based on the user input
 * prompt can be returned.
 */
const useCreateBuildWithAIRevisionPredictionAsync = () => useMutation(CreateBuildWithAIRevisionPredictionAsync);
export default useCreateBuildWithAIRevisionPredictionAsync;